import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class BankTransferPaymentOption
 * @property {integer} id
 * @property {Property} property
 * @property {integer} type
 * @property {integer} accept_on_direct_reservations
 * @property {integer} accept_on_booking_engine
 * @property {string} instruction
 * @property {string} instruction_ar
 */
export class BankTransferPaymentOption extends TranslatableModel {
    
    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'instruction' ];
    }
    
    static get validationModel() {
        
        return {
            instruction: {
                label: 'INSTRUCTIONS_IN_ENGLISH',
                commonLabel: 'Instructions'
            },
            instruction_ar: {
                label: 'INSTRUCTIONS_IN_ARABIC',
                commonLabel: 'Instructions'
            }
        };
    }
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
}

AccessorsMutatorsDecorator('id', ...BankTransferPaymentOption.translatableAttributesWithLanguageAliases, 'property', 'property_id', 'status', 'allow_direct_reservations', 'allow_booking_engine')(BankTransferPaymentOption);



// WEBPACK FOOTER //
// ./src/pms-api/models/bank-transfer-payment-option.model.js